<template>
<div>
  <div v-if="!loaded" class="loader">
    <i class="fa fa-4x fa-spinner fa-spin"></i>
  </div>
  <div class="main-container" v-if="loaded">

    <!-- <b-navbar-nav class="ml-auto user-name">
      <Header/>
    </b-navbar-nav> -->
    <!-- <header/> -->
    <HeaderFront/>

    <div class="container" id="page-container">
      <router-view/>
    </div>

    <FooterFront/>

    <!-- <footer/> -->
  </div>
</div>
</template>
<script>
import HeaderFront from './Header_front.vue'
import FooterFront from './Footer_front.vue'


export default {
  name: 'container',
  components: {
      HeaderFront,
      FooterFront,
    // Header     
  },
  data() {
      return {
          loaded: false
      }
  },
  created() {
      this.loaded = true
  }
}
</script>

